import { createAsyncThunk } from '@reduxjs/toolkit';
import fileApi from '~/apis/file';
import { GET_FILE, GENERATE_SIGN_DOCUMENT, UPDATE_FILE } from '~/utils/constants/actionType';
import { IPayloadEditFile, IPayloadGenerateSignDocument, IResponseGetFile } from '~/utils/interface/file';

export const handleGetFile = createAsyncThunk<IResponseGetFile, { id: string | undefined }>(
  GET_FILE,
  async ({ id }, { rejectWithValue }) => {
    try {
      const res = await fileApi.getFile(id);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleUpdateFile = createAsyncThunk<null, { id: string | undefined; data: IPayloadEditFile }>(
  UPDATE_FILE,
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await fileApi.updateFile(id, data);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleGenerateSignDocument = createAsyncThunk<IResponseGetFile, IPayloadGenerateSignDocument>(
  GENERATE_SIGN_DOCUMENT,
  async (data, { rejectWithValue }) => {
    try {
      const res = await fileApi.generateSignDocument(data);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
